import { createReducer, on } from "@ngrx/store";
import { createBadge, createBadgeFailure, createBadgeSuccess, createQrCodeImage, createQrCodeImageFailure, createQrCodeImageSuccess, getAllBadge, getAllBadgeFailure, getAllBadgeSuccess } from "../actions/badge.action";
import { getAllChartObject, getAllChartObjectFailure, getAllChartObjectPerDate, getAllChartObjectPerDateFailure, getAllChartObjectPerDateSuccess, getAllChartObjectSuccess } from "../actions/chartObject.action";

export interface BadgeState {
  badges: any;
  chartsObjects: ReadonlyArray<any>;
  chartsObjectsByDates: ReadonlyArray<any>;
  responseDAO: any;
  error: string | null;
}

export interface ChartBadgesObjectState {
  chartsObjects: ReadonlyArray<any>
}

export interface ChartBadgesObjectPerDateState {
  chartsObjectsByDates: ReadonlyArray<any>
}


export const initialState: BadgeState = {
  badges: {
    content: [],
    totalPages: 0,
    totalElements: 0,
    pageable: {
      pageNumber: 0,
      pageSize: 20
    }
  },
  chartsObjects: [],
  chartsObjectsByDates: [],
  responseDAO: null,
  error: null
}

export const badgeReducer = createReducer(
  initialState,
  on(getAllBadge, (state) => ({ ...state })),
  on(getAllBadgeSuccess, (state, { badges }) => ({ ...state, badges })),
  on(getAllBadgeFailure, (state, { error }) => ({ ...state, error })),
  on(getAllChartObject, (state) => ({ ...state })),
  on(getAllChartObjectSuccess, (state, { chartsObjects }) => ({ ...state, chartsObjects })),
  on(getAllChartObjectFailure, (state, { error }) => ({ ...state, error })),
  on(getAllChartObjectPerDate, (state) => ({ ...state })),
  on(getAllChartObjectPerDateSuccess, (state, { chartsObjectsByDates }) => ({ ...state, chartsObjectsByDates })),
  on(getAllChartObjectPerDateFailure, (state, { error }) => ({ ...state, error })),
  on(createBadge, (state) => ({ ...state })),
  on(createBadgeSuccess, (state, { responseDAO }) => ({ ...state, responseDAO })),
  on(createBadgeFailure, (state, { error }) => ({ ...state, error })),
  on(createQrCodeImage, (state) => ({ ...state })),
  on(createQrCodeImageSuccess, (state) => ({ ...state })),
  on(createQrCodeImageFailure, (state) => ({ ...state }))
)
